export default function splitstring(input="",delimiter){
    let arr = input.split(delimiter);

    return arr.join("\n");
}